import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesignColorsInserterComponent } from './design-colors-inserter.component';

@NgModule({
  declarations: [DesignColorsInserterComponent],
  imports: [
    CommonModule
  ],
  exports: [
    DesignColorsInserterComponent
  ]
})
export class DesignColorsInserterModule { }
